/*
 * サブシステム名：マスタ管理
 * 機能名：取引先マスタ一覧
 */
import DdDefaultButton from '@/components/DdDefaultButton'
import DdFooterButton from '@/components/DdFooterButton'
import DdCustomButton from '@/components/DdCustomButton'

import date from '@/ddv2.library/date'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'
import header from '@/ddv2.library/header'

const DdCodeTextBox = () => import('../../../components/DdCodeTextBox.vue')
const DdDataTable = () => import('@/components/DdDataTable')
const DdDropDown = () => import('@/components/DdDropDown')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdNarrowDownTextBox = () => import('@/components/DdNarrowDownTextBox')
const DdRadioButton = () => import('@/components/DdRadioButton')
const DdRowCountBox = () => import('@/components/DdRowCountBox')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTextBox = () => import('@/components/DdTextBox')

export default {
  name: 'MstTorihikisakiList',
  mixins: [flowMixin],
  data: () => ({
    expansionPanel: [0, 1],
    selected: [],
    conditions: {
      torihikisakiCd: '',
      torihikisakiKbn: '0',
      tokuisakiFlg: true,
      shiiresakiFlg: true,
      hacchusakiFlg: true,
      torihikisakiNm: '',
      torihikisakiNmKana: '',
      shanaiTantoshaCd: '',
      torihikisakiBunruiKbn1: null,
      torihikisakiBunruiKbn2: null,
      torihikisakiBunruiKbn3: null
    },
    headersShanaishuTantoshaList: header.mstJininHeaders,
    modeKengen: 0,
    page: 1
    /*
    headersShanaishuTantoshaList: [
      { width: '60px', text: '社内主担当者コード', value: 'jininCd' },
      { width: '90px', text: '社内主担当者名', value: 'jininNm' }
    ]
    */
  }),
  components: {
    DdCustomButton,
    DdDefaultButton,
    DdFooterButton,
    DdCodeTextBox,
    DdDataTable,
    DdDropDown,
    DdIconButtonWithTooltip,
    DdNarrowDownTextBox,
    DdRadioButton,
    DdRowCountBox,
    DdSubHeader,
    DdTextBox
  },
  computed: {
    filteredRows () {
      return this.rows.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        elem.hyojiOrderDisp = elem.hyojiOrder ? filter.numericFormatter(elem.hyojiOrder) : ''
        return elem
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    isEditButtonDisabled () {
      if (this.modeKengen === 0) {
        return true
      }
      if (this.selected.length === 1) {
        return false
      }
      return true
    },
    isAddButtonDisplay () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    },
    ...mapGetters({
      jininList: 'DDMasters/mstJinin',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      shubetsuList: 'DDMasters/mstShubetsu',
      helpUseFlg: 'DDMasters/helpUseFlg'
    }),
    filteredShanaishuTantoshaList () {
      const target = filter.dateFormatter(new Date())
      return this.jininList.map((elem) => {
        elem.jininNm = elem.jininNmSei + (elem.jininNmMei ? ' ' + elem.jininNmMei : '')
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.jininCd > elem2.jininCd) { return 1 }
        if (elem1.jininCd === elem2.jininCd) { return 0 }
        return -1
      })
    },
    torihikisakiBunruiKbn1List () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT002')
    },
    torihikisakiBunruiKbn2List () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT003')
    },
    torihikisakiBunruiKbn3List () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT004')
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        conditions: this.conditions,
        searchText: this.searchText,
        rows: this.rows
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msttorihikisaki', 'mstjinin', 'mstshubetsu'],
        defineHeaderPromise: () => {
          return new Promise((resolve) => {
            console.log('MstToriikisakiList.defineHeaderPromise')
            self.headers = [
              { text: '編集', value: 'actions', sortable: false, width: '20px' },
              { text: '取引先コード', value: 'torihikisakiCd' },
              { text: '得意先', value: 'tokuisaki', align: 'center' },
              { text: '仕入先', value: 'shiiresaki', align: 'center' },
              { text: '発注先', value: 'hacchusaki', align: 'center' },
              { text: '取引先名称', value: 'torihikisakiNm' },
              { text: '取引先名称カナ', value: 'torihikisakiNmKana' },
              { text: '取引先正式名称', value: 'torihikisakiSeishikiNm' },
              { text: '取引先略称', value: 'torihikisakiAbbr' },
              // { text: '社内主担当者', value: 'shanaiTantoshaNm' },
              // { text: '地域種別', value: 'chiikiKubunNm' },
              // { text: '地区種別', value: 'chikuKubunNm' },
              // { text: '取引先分類区分１', value: 'torihikisakiBunruiKubun1Nm' },
              // { text: '取引先分類区分２', value: 'torihikisakiBunruiKubun2Nm' },
              // { text: '取引先分類区分３', value: 'torihikisakiBunruiKubun3Nm' },
              { text: '郵便番号', value: 'yubinNo' },
              { text: '住所１', value: 'jusho1' },
              { text: '住所２', value: 'jusho2' },
              { text: '住所３', value: 'jusho3' },
              { text: '電話番号', value: 'telNo' },
              { text: 'FAX番号', value: 'faxNo' },
              { text: 'メールアドレス', value: 'mailAddress' },
              { text: '部署名', value: 'bushoNm' },
              { text: '担当者名', value: 'tantoshaNm' },
              { text: '適用開始年月日', value: 'tekiyoStartYmdDisp', align: 'center' },
              { text: '適用終了年月日', value: 'tekiyoEndYmdDisp', align: 'center' },
              { text: '表示順', value: 'hyojiOrderDisp', align: 'end' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            console.log('initializeInputPromise')
            self.conditions = {
              torihikisakiCd: '',
              torihikisakiKbn: '0',
              tokuisakiFlg: false,
              shiiresakiFlg: false,
              hacchusakiFlg: false,
              torihikisakiNm: '',
              torihikisakiNmKana: '',
              shanaiTantoshaCd: '',
              torihikisakiBunruiKbn1: null,
              torihikisakiBunruiKbn2: null,
              torihikisakiBunruiKbn3: null
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('MstTorihikisakiList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('MstTorihikisakiList.savedInputRestorePromise after loadFromCache', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('MstTorihikisakiList.researchPromise', c)
          return new Promise(resolve => {
            if (c.cache.value) {
              self.conditions = c.cache.value.conditions || {}
            }
            self.onSearchButtonClick()
            resolve()
            // self.search().then(() => {
            //   resolve()
            // })
          })
        },
        restoreViewPromise: (c) => {
          console.log('MstTorihikisakiList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      this.selected = []

      const self = this
      const opt = {
        searchRequestPromise: function () {
          self.setSelectedKbn()
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/Tgmstd0030/Search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
            torihikisakiKbn: self.conditions.torihikisakiKbn
          }
        }
      }
      this.search(opt)
    },
    /*
    onSearchButtonClick: function (e) {
      const isValid = this.validateAll(this.$refs)
      console.log('validate all', isValid)
      if (isValid) {
        this.Effects.loadStart()
        console.log('コンディション')
        console.log(this.conditions)
        this.search().then(() => {
          console.log('this.search()', this.rows)
          this.Effects.loadComplete()
        })
      }
    },
    search: function () {
      this.setSelectedKbn()
      return new Promise(resolve => {
        this.HttpClient
          .post('/api/v1/VwCMstTorihikisaki/Search', this.conditions)
          .then((data) => {
            console.log(data.payload)
            this.rows = data.payload

            const cache = {
              rows: this.rows,
              conditions: this.conditions,
              searchText: this.searchText
            }

            this.saveToChache(cache)
              .then(() => {
                resolve()
              })
          })
      })
    },
    */
    setSelectedKbn: function () {
      const kbn = this.conditions.torihikisakiKbn
      this.conditions.tokuisakiFlg = kbn === '1'
      this.conditions.shiiresakiFlg = kbn === '2'
      this.conditions.hacchusakiFlg = kbn === '3'
    },
    onClearButtonClick: function (e) {
      console.log('clear pushed')
      this.Effects.loadStart()
      this.clear()
    },
    clear: function () {
      console.log('clear pushed')
      const self = this
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            self.conditions = {
              torihikisakiCd: '',
              torihikisakiKbn: '0',
              tokuisakiFlg: false,
              shiiresakiFlg: false,
              hacchusakiFlg: false,
              torihikisakiNm: '',
              torihikisakiNmKana: '',
              shanaiTantoshaCd: '',
              torihikisakiBunruiKbn1: null,
              torihikisakiBunruiKbn2: null,
              torihikisakiBunruiKbn3: null
            }
            self.searchText = ''
            self.rows = []
            self.selected = []
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onRowDoubleClick: function (e, f) {
      console.log(e, f)
      this.Effects.loadStart()
      this.transition(0, { id: f.item.id })
    },
    onRowEditButtonClick: function (item) {
      // 画面遷移
      console.log('onRowEditButtonClick', item)
      this.Effects.loadStart()
      this.transition(0, { id: item.id })
    },
    onCsvButtonClick: function (e) {
      this.HttpClient.post('/api/v1/VwCMstTorihikisaki/download', this.conditions).then((data) => {
        const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
        const bom = new Uint8Array([0xef, 0xbb, 0xbf])
        const blob = new Blob([bom, data], { type: 'text/csv' })
        const elem = document.getElementById('download')
        elem.href = window.URL.createObjectURL(blob)
        elem.download = '取引先マスタ一覧_' + ts + '.csv'
        elem.click()
      })
    },
    onCreateButtonClick: function (e) {
      console.log('onCreateButtonClick 0', e)
      this.Effects.loadStart()
      this.transition(0, { id: 0 })
    },
    searchValidate: function () {
      return true
    },
    usableDblClick (item) {
      return 'usable-dblclick'
    }
  }
}
